import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator
} from "firebase/firestore";
import { app } from "./config.js";

// Keep a device cache (IndexedDB) so the PWA shows data offline and reopens faster.
// Falls back to the default in-memory cache where IndexedDB isn't available (e.g. some private modes).
function createDb() {
  if (typeof window === "undefined" || typeof indexedDB === "undefined") return getFirestore(app);
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
    });
  } catch (err) {
    console.warn("[Firestore] Persistent cache unavailable, using memory cache:", err.message);
    return getFirestore(app);
  }
}

export const db = createDb();

if (typeof import.meta !== "undefined" && import.meta.env?.VITE_USE_EMULATOR === "true") {
  const port = Number(import.meta.env?.VITE_EMULATOR_FIRESTORE_PORT || 8080);
  try {
    connectFirestoreEmulator(db, "127.0.0.1", port);
    console.log(`[Firestore] Connected to local emulator on 127.0.0.1:${port}`);
  } catch (err) {
    console.warn("[Firestore] Emulator notice:", err.message);
  }
}

export default db;
